module.exports = __webpack_public_path__ + "img/logo-with-transparency.18852882.png";